// extracted by mini-css-extract-plugin
export default {"awardsWrapper":"awards-module--awardsWrapper--3xtki","itemWrapper":"awards-module--itemWrapper--3-MSB"};